import React from 'react';
import Form from 'react-bootstrap/Form'
import { Space } from 'antd';
import ReqSosOutage from './ReqSosOutage';
import PreEDate from '../PreEFormFields/PreEDate';
import IPSLocationHeader from '../PreEFormFields/IPSLocationHeader';
import IPSLocations from '../PreEFormFields/IPSLocations';
import FormTitle from "./FormTitle";
import EnergizationStatus from "./EnergizationStatus";
import Spinner from "../../../components/Spinner";


const PreEFormFields = ({ ...props}) =>
        <>
            <Spinner />
            <Form>
              <Space direction="vertical">
                <FormTitle {...props}/>
                <PreEDate {...props}  />
                <EnergizationStatus {...props} />
                <ReqSosOutage {...props} />
                <IPSLocationHeader />
                <IPSLocations {...props}/>
              </Space>
            </Form>
        </>;

export default PreEFormFields;
